module.exports = __webpack_public_path__ + "static/media/e-commerce.d716018a.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/objects/e-commerce.svg
// module id = 1082
// module chunks = 36